import React from 'react'

export default function SortBothIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 17 16" fill="none">
            <path d="M9.01543 13.512C8.81527 13.7622 8.43473 13.7622 8.23457 13.512L5.27488 9.81235C5.01297 9.48497 5.24606 9 5.66531 9H11.5847C12.0039 9 12.237 9.48497 11.9751 9.81235L9.01543 13.512Z" fill="currentcolor" />
            <path d="M9.01543 2.48804C8.81527 2.23784 8.43473 2.23784 8.23457 2.48804L5.27488 6.18765C5.01297 6.51503 5.24606 7 5.66531 7H11.5847C12.0039 7 12.237 6.51503 11.9751 6.18765L9.01543 2.48804Z" fill="currentcolor" />
        </svg>
    )
}